import React from 'react';
import styles from './Shared.module.css';
import { MenuItem, Select } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function ListPicker({ options, selected, setSelected }) {
  const { t } = useTranslation();
  return (
    <div className={styles.timePresetPickerContainer}>
      <Select
        classes={{
          root: styles.timePresetPickerText
        }}
        defaultValue={selected}
        value={selected}
        disableUnderline={true}
        onChange={(e) => setSelected(e.target.value)}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {t(option)}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

export default ListPicker;
